// Module
var code = "<template> <require from=\"app/core/components/documents/document-categories-grid\"></require> <section id=\"manage-attached-document-categories-page-view\"> <document-categories-grid documents-config.bind=\"documentsConfig\"></document-categories-grid> </section> </template> ";
// Exports
module.exports = code;